<template>
    <div id="root">
        <nav-bar id="navbar" />
        <search-form />
        <div id="maincontent">
            <slot />
        </div>
        <Footer id="footer" />
	</div>
</template>

<script>
    // HELPERS
    import _GlobalHelper from '@/store/helpers/global'
	// COMPONENTS
    import SearchForm from '@/components/SearchForm/Index'
    import NavBar from '@/components/NavBar/Index'
    import Footer from '@/components/Footer/Index'
    
    import { mapGetters, mapMutations } from 'vuex'

	export default {
		name: 'default',
		components: {
            SearchForm,
            'nav-bar': NavBar,
            Footer : Footer,
		},
		data() {
			return {
                height: null,
                min_height: '0',
			}
		},
        computed: {
            ...mapGetters ({
                show_search_form: _GlobalHelper.getters.show_search_form
            }),
        
        },
		methods: {
            ...mapMutations({
                set_modal: _GlobalHelper.mutations.modal,
                set_loading: _GlobalHelper.mutations.loading
            })
        },
        created() {
            // window.addEventListener('beforeunload', (e) => {
            //     (e || window.event).returnValue = "still there?"
            //     return ''
            // })
        },
        /*updated() {

            this.height = {
                screen: window.screen.height,
                browser: document.documentElement.offsetHeight,
                navbar: document.getElementById("navbar").offsetHeight,
                //search_form: (this.showSearchForm) ? document.getElementById("search").offsetHeight : 0,
                footer: document.getElementById("footer").offsetHeight
            }
            this.min_height = this.height.screen - (this.height.navbar + this.height.search_form + this.height.footer)

            document.getElementById("maincontent").style.minHeight = this.min_height.toString() + 'px'
        },*/
        
	}
</script>


<style lang="scss">
    #maincontent {
        padding: 0px;
    }
</style>